import * as React from 'react';
import * as  moment from 'moment';
import * as  _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import { Environment } from '../../../../../const/environment';
import capitalize from '../../../../../services/mini/capitalize';
import platformNames from '../../../../../const/platformNames';
import formats from '../../../../../const/formats';

export function WakeWordOptionsItem({ wakeWordItem, selectedWakeWordId, project, onItemCopy, onItemDelete }) {

    const copyItemCb = React.useCallback((e) => {
        onItemCopy(wakeWordItem, e);
    }, [onItemCopy, wakeWordItem]);

    const deleteItemCb = React.useCallback((e) => {
        onItemDelete(wakeWordItem, e);
    }, [onItemDelete, wakeWordItem]);

    let canNotDeleteItemMsg = '';

    const tempEnvironments = [Environment.Staging, Environment.Testing, Environment.Production];

    const whereItemAreUsed = [];

    for (let i = 0; i < tempEnvironments.length; i++) {
        const curEnvironment = tempEnvironments[i];
        const options = JSON.parse(project[`${curEnvironment}Options`] || null) || {};
        const keys = Object.keys(options);

        for (let j = 0; j < keys.length; j++) {
            if (selectedWakeWordId === wakeWordItem.id) {
                whereItemAreUsed.push(`on ${platformNames[keys[j]]} platform in ${capitalize(curEnvironment)} environment`);
            }
        }
    }

    if (whereItemAreUsed.length > 0) {
        canNotDeleteItemMsg = `This wake word cannot be deleted because it is used: ${whereItemAreUsed.join(', ')}`;
    }

    return (
        <div className="wakeword-options-item">
            {wakeWordItem.isPredefined ?
                <div
                    className="wakeword-options-item_content default">
                    <div className="wakeword-options-item_content_name">
                        {wakeWordItem.name}<i className="icon icon-alan-lock" />
                    </div>
                </div> :
                <div
                    className="wakeword-options-item_content">
                    <div className="wakeword-options-item_content_name">
                        {wakeWordItem.updateTs &&
                            <div className="wakeword-options-item_content_date">
                                {moment(+wakeWordItem.updateTs).format(formats.MMM_DD_hh_mm_a)}
                            </div>}
                        <div className="wakeword-options-item_content_name_text"
                            title={wakeWordItem.name}>
                            {wakeWordItem.name}
                        </div>

                        <i className="icon icon-alan-edit"
                            title="Edit wake word"
                            onClick={copyItemCb} />

                        <i
                            title="Delete wake word"
                            data-effect="solid"
                            data-place="right"
                            data-for="deleteWakeWordTooltip"
                            data-tip={canNotDeleteItemMsg}
                            data-multiline="true"
                            data-class="tutor-dark-tooltip cannot-delete-wakeword-tooltip"
                            className={`icon icon-alan-trash ${canNotDeleteItemMsg && 'disabled-with-cursor'}`}
                            onClick={canNotDeleteItemMsg ? undefined : deleteItemCb} />
                        {canNotDeleteItemMsg && <ReactTooltip id="deleteWakeWordTooltip" />}
                    </div>
                </div>}

        </div>
    );
}